import type { AudioClip } from '../../format/types';
import { useTimeline } from '../../state/timeline';
import { Num, Slider } from './fields';

export default function AudioClipInspector({ clip }: { clip: AudioClip }) {
  const update = useTimeline((s) => s.updateClip);
  const patch = (p: Partial<AudioClip>) => update(clip.id, p);
  return (
    <>
      <div className="insp-section">
        <h3>Audio clip</h3>
        <Num label="start" value={clip.start} min={0} onChange={(v) => patch({ start: Math.max(0, v) })} />
        <Num
          label="in"
          value={clip.in}
          min={0}
          onChange={(v) => patch({ in: Math.max(0, Math.min(v, clip.out - 0.05)) })}
        />
        <Num label="out" value={clip.out} onChange={(v) => patch({ out: Math.max(clip.in + 0.05, v) })} />
        <Slider label="gain" value={clip.gain} min={0} max={2} step={0.05} onChange={(v) => patch({ gain: v })} />
        {/* Varispeed: pitch shifts with it, in preview and export alike. */}
        <Slider
          label="speed"
          value={clip.speed ?? 1}
          min={0.25}
          max={4}
          step={0.05}
          onChange={(v) => patch({ speed: v })}
        />
      </div>
      <div className="insp-section">
        <h3>Fades</h3>
        <Num label="fade in" value={clip.fadeIn} min={0} onChange={(v) => patch({ fadeIn: Math.max(0, v) })} />
        <Num
          label="fade out"
          value={clip.fadeOut}
          min={0}
          onChange={(v) => patch({ fadeOut: Math.max(0, v) })}
        />
      </div>
    </>
  );
}
